/**
 * MobileCloudCodeToggle Component
 * 
 * On mobile, we only show the Functions view (no toggle between Files/Functions).
 * This component only renders the refresh button.
 */

interface MobileCloudCodeToggleProps {
  /** Callback to refresh cloud code */
  onRefresh?: () => void;
  /** Whether cloud code is currently refreshing */
  isRefreshing?: boolean;
}

export default function MobileCloudCodeToggle({
  onRefresh,
  isRefreshing,
}: MobileCloudCodeToggleProps) {
  return (
    <div className="flex items-center justify-end w-full">
      {/* Refresh Button only - no Files/Functions toggle on mobile */}
      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          disabled={isRefreshing}
          className={`
            flex-shrink-0 w-[40px] h-[40px] rounded-xl flex items-center justify-center
            transition-all duration-200
            ${isRefreshing 
              ? 'bg-[#1a2436] text-white/30 cursor-not-allowed border border-white/10' 
              : 'bg-[#1a2436] text-white/50 hover:text-white/80 hover:bg-[#243044] border border-white/10'}
          `}
          style={{ backgroundColor: '#1a2436' }}
          title="Refresh cloud code"
        >
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
            className={isRefreshing ? 'animate-spin' : ''}
          >
            <path d="M23 4v6h-6M1 20v-6h6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  );
}
